import { Translation } from '@ps/web-shared-components';
import React, { useEffect } from 'react';

import useTimer from '@swf/core/hooks/useTimer';
import { secondsToFormattedTime } from '@swf/core/utils/index';

import { TXTCLI_Collect_inX_N0 } from './PlayMoneyCollect.messages.json';

const modifier = (s: number) => s - 1;

interface Props {
  refillTime: number;
  setRefillTime(time: number): void;
}

const PlayMoneyCollect: React.FC<Props> = ({ refillTime: initial, setRefillTime }) => {
  const timer = useTimer({ modifier, initial });

  useEffect(() => {
    if (timer < 0) {
      setRefillTime(0);
    }
  }, [setRefillTime, timer]);

  return (
    <Translation values={{ 0: secondsToFormattedTime(timer * 1000) }} {...TXTCLI_Collect_inX_N0} />
  );
};

export default PlayMoneyCollect;
